/**
 * Route → permission-key map for Learning (sc-1245).
 *
 * A map of the routes we ship, NOT a catalog — the permissions that exist live
 * in the database and reach the app through the API. Same contract as
 * {@link ../permissions/backoffice-permissions}: a key added by a migration but
 * absent here still shows up in the permissions picker, it just does not drive
 * navigation until a route exists for it.
 */
export const LEARNING_PERMISSION_KEYS = {
  /** The learner key: see the Learning area and work through assigned courses. */
  catalog: 'learning.catalog',
  author: 'learning.author',
  assign: 'learning.assign',
  reports: 'learning.reports',
} as const

/**
 * Holding anything under this prefix means "some Learning access at all".
 *
 * The nav item and the layout route gate on the prefix rather than on
 * `catalog`, so someone granted only `learning.author` — an author who is not
 * themselves enrolled — can still reach the area they administer.
 */
export const LEARNING_PREFIX = 'learning.'
